// FixedHeader.js

import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/CommonCtx';
//import { useTheme } from "@emotion/react";
import { styled } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
//import Collapse from '@mui/material/Collapse';
//import List from '@mui/material/List';
//import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import Link from '@mui/material/Link';
import PersonIcon from '@mui/icons-material/Person';
//import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LanguageIcon from '@mui/icons-material/Language';
//import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
//import LabelIcon from '@mui/icons-material/Label';
//import ExpandLessIcon from '@mui/icons-material/ExpandLess';
//import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

function FixedHeader() {

    //const theme = useTheme();
    //const navigate = useNavigate();
    
    const { ip, user, setUser, setMode, ml, setMl, ppms, port } = useAuth();
    //console.log('main_user', user);
   
    //const mlang = { 'ko': 'LANG_KO', 'en': 'LANG_EN' };
    //const pages = [ ml.SITE_PICTURES, ml.SITE_INSPECT, ml.ISSUE_MGMT, ml.ASSET_MGMT ];
    const pages = [
        //ml.ISSUE_REG, ml.PHOTO_REG, ml.INSPECTION, ml.SAFETY_INSPECT, ml.TBM, ml.SAFETY_INSTR, ml.QUAL_INSPECT, ml.MATL_MGT, ml.MEMO, ml.NOTICE_BOARD
        ml.ISSUE_REG, ml.PHOTO_REG, ml.PANO_360, ml.NOTICE_BOARD
    ];
    //const pageNavs = [ 'sitepics', 'siteinsp', 'issuemgmt', 'assetmgmt' ];
    const pageModes = [
        //'IssueReg', 'SitePics', 'SiteInsp', 'SafInsp', 'TBM', 'SafInstr', 'QualInsp', 'MatlMgt', 'Pano360', 'NotiBrd'
        'IssueReg', 'SitePics', 'Pano360', 'NotiBrd'
    ];

    const [ anchorElNav, setAnchorElNav ] = useState(null);
    const [ anchorElUser, setAnchorElUser ] = useState(null);
    //const [ open, setOpen ] = useState(false);
    const [ ln, setLn ] = useState(user.lang);

    useEffect(() => {
    }, []);

    if (!user.lang){
        return <Navigate replace to='/signin' />; 
    }

    //const handleLangMenu = () => {
    //    setOpen(!open);
    //};

    const changeLang = async(lang) => {
        try {
            const res = await axios.get(`${ppms}:${port}/appms/ml/${lang}`, { withCredentials: true });
            //console.log('lang_res', res);

            // set language
            setMl(res.data);

            //const data = { ip: ip };
            const data = new URLSearchParams({
                ip: ip
            });
            //const r = await axios.post(`${ppms}:${port}/appms/auth`, data, { 'Content-Type': 'application/json', withCredentials: true });
            const r = await axios.post(`${ppms}:${port}/appms/auth`, data, { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', withCredentials: true });
            //console.log('auth_res', r);

            // set user info
            setUser(r.data);

            //setLn(mlang[r.data.lang]);
            setLn(r.data.lang);

            //<Navigate replace to='/' />

        } catch(err) {
            console.log(err);
        }
    };

    const handleLang = (e) => {
        //console.log(e);

        //let lang = e.target.textContent;
        /*
        let lang = e.target.value;
        if (lang === ml.LANG_KO) {
            changeLang('ko');
        } else if (lang === ml.LANG_EN) {
            changeLang('en');
        } else {
            changeLang('en');
        }
        */
        changeLang(e.target.value);

        setAnchorElUser(null);
    };
  
    const handleOpenNavMenu = (e) => {
        setAnchorElNav(e.currentTarget);
    };
    const handleOpenUserMenu = (e) => {
        setAnchorElUser(e.currentTarget);
    };
  
    const handleCloseNavMenu = () => {
       setAnchorElNav(null);
    };
  
    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const handleNavMenu = (e) => {
        console.log('navmenu', e);

        const idx = pages.indexOf(e.target.textContent);
        //if (idx !== -1) navigate(pageNavs[idx]);
        if (idx !== -1) setMode(pageModes[idx]);

        setAnchorElNav(null);
    };

    const handleLogout = async() => {
        setAnchorElUser(null);

        // logout
        try {
            await axios.get(`${ppms}:${port}/appms/logout`, { withCredentials: true });
            //const res = await axios.get(`${ppms}:${port}/appms/logout`, { withCredentials: true });
            //console.log('auth_res', res);

            // set user info
            setUser({});
            setMode('logout');
        } catch(err) {
            console.log(err);
        }
    };

    const TypoLogoMd = styled(Typography)(({theme}) => ({
        mr: 2,
        display: { xs: 'none', md: 'flex' },
        fontFamily: 'monospace',
        fontWeight: 700,
        letterSpacing: '.3rem',
        color: 'inherit',
        textDecoration: 'none',
    }));
    const TypoLogoXs = styled(Typography)(({theme}) => ({
        mr: 2,
        display: { xs: 'flex', md: 'none' },
        flexGrow: 1,
        fontFamily: 'monospace',
        fontWeight: 700,
        letterSpacing: '.3rem',
        color: 'inherit',
        textDecoration: 'none',
    }));
  
    return (
        <AppBar component="nav">
        {/* <AppBar position="static"> */}
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    <Link href="/">
                        <Box component="img" sx={{ height: 54, display: { xs: 'none', md: 'flex' }, mr: 1 }} alt="Logo" src={'/logo192.png'} />
                    </Link>
                    <TypoLogoMd variant="h6" noWrap component="a" href="#"></TypoLogoMd>
                    <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                        <Tooltip title="Account settings">
                            <IconButton size="large" color="inherit" aria-label="Current user" aria-controls="menu-appbar" aria-haspopup="true" onClick={handleOpenNavMenu}>
                                <MenuIcon />
                            </IconButton>
                        </Tooltip>
                        <Menu id="menu-appbar" keepMounted 
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{
                                display: { xs: 'block', md: 'none' },
                            }}
                          >
                              {pages.map((page, idx) => (
                                  <MenuItem key={idx} onClick={handleNavMenu}>
                                      <Typography textAlign="center">{page}</Typography>
                                  </MenuItem>
                              ))}
                        </Menu>
                    </Box>
                    <Link href="/">
                        <Box component="img" sx={{ height: 54, display: { xs: 'flex', md: 'none' }, mr: 0, }} alt="Logo" src={'/logo192.png'} />
                    </Link>
                    <TypoLogoXs variant="h5" noWrap component="a" href="#"></TypoLogoXs>
                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                        {pages.map((page, idx) => (
                            <Button key={idx} onClick={handleNavMenu} sx={{ my: 2, color: 'white', display: 'block' }}>
                                {page}
                            </Button>
                        ))}
                    </Box>
                    <Box sx={{ flexGrow: 0 }}>
                        {/* <Tooltip title="Open settings"> */}
                        <Tooltip title={user.real_name}>
                            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                                <Avatar sx={{ bgcolor: '#c5cae9' }}>
                                    <PersonIcon />
                                </Avatar>
                            </IconButton>
                        </Tooltip>
                        <Menu sx={{ mt: '45px' }} id="menu-appbar" keepMounted
                            anchorEl={anchorElUser}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorElUser)}
                            onClose={handleCloseUserMenu}
                        >
                            {/*
                            <MenuItem onClick={handleCloseUserMenu}>
                                <ListItemIcon>
                                    <AccountCircleIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary="Profile" />
                            </MenuItem>
                            */}
                            <MenuItem>
                                <ListItemIcon>
                                    <LanguageIcon fontSize="small" />
                                </ListItemIcon>
                                <FormControl variant="standard" sx={{ m: 1 }} size="small">
                                    <Select id="sel-lang" value={ln} onChange={handleLang} label="Language" sx={{ border: 0 }} disableUnderline>
                                        <MenuItem value="ko">{ml.LANG_KO}</MenuItem>
                                        <MenuItem value="en">{ml.LANG_EN}</MenuItem>
                                    </Select>
                                    {/*
                                    <Select id="sel-lang" value={ ln ? ml[ln] : ml[mlang[user.lang]] } onChange={handleLang} label="Language" sx={{ border: 0 }} disableUnderline>
                                        <MenuItem value={ml.LANG_KO}>{ml.LANG_KO}</MenuItem>
                                        <MenuItem value={ml.LANG_EN}>{ml.LANG_EN}</MenuItem>
                                    </Select>
                                    */}
                                </FormControl>
                            </MenuItem>
                            {/*
                            <MenuItem onClick={handleLangMenu}>
                                <ListItemIcon>
                                    <LanguageIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary="Language" />
                                {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                            </MenuItem>
                            <Collapse in={open} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>
                                    <ListItemButton sx={{ pl: 2 }} value="ko" onClick={handleLang}>
                                        <ListItemIcon sx={{ justifyContent: 'center' }}>
                                            <LabelIcon fontSize="small" />
                                        </ListItemIcon>
                                        <ListItemText primary="Korean" />
                                    </ListItemButton>
                                    <ListItemButton sx={{ pl: 2 }} value="en" onClick={handleLang} >
                                        <ListItemIcon sx={{ justifyContent: 'center' }}>
                                            <LabelIcon fontSize="small" />
                                        </ListItemIcon>
                                        <ListItemText primary="English" />
                                    </ListItemButton>
                                </List>
                            </Collapse>
                            */}
                            <Divider />
                            {/*
                            <MenuItem onClick={handleCloseUserMenu}>
                                <ListItemIcon>
                                    <SettingsIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary="Settings" />
                            </MenuItem>
                            */}
                            <MenuItem onClick={handleLogout}>
                                <ListItemIcon>
                                    <LogoutIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={ml.LOGOUT} />
                            </MenuItem>
                        </Menu>
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
};

export default FixedHeader;


